/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

type NonConsecutiveSeatCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

/**
 * 「席離れ可」同意チェックボックス。表示制御はしない純粋な UI。
 */
export const NonConsecutiveSeatCheckbox = ({
  checked,
  onChange,
}: NonConsecutiveSeatCheckboxProps) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: flex-start;
        gap: 8px;
        max-width: 500px;
        margin: 16px auto 0;
        font-size: 14px;
        * {
          cursor: pointer;
        }
      `}
    >
      <input
        type="checkbox"
        id="allowNonConsecutive"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ flexShrink: 0, marginTop: "3px" }}
      />
      <label htmlFor="allowNonConsecutive" style={{ lineHeight: "1.5" }}>
        {"席離れ可"}
        <br />
        <span style={{ fontWeight: "normal", fontSize: "12px" }}>
          {
            "連番（お隣同士）でのご用意ができません。チェックすると、席が離れてもよいものとして購入します。席が離れた場合でも、変更・キャンセル・返金はできません。"
          }
        </span>
      </label>
    </div>
  );
};
